import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin';
import { Conjoint } from 'model/model.conjoint';

@Component({
  selector: 'app-statistique-rembourse-agent',
  templateUrl: './statistique-rembourse-agent.component.html',
  styleUrls: ['./statistique-rembourse-agent.component.scss']
})
export class StatistiqueRembourseAgentComponent implements OnInit {
  agents: Array<Conjoint> = new Array<Conjoint>();
  date_debut: Date;
  date_fin: Date;
  agent: Conjoint = new Conjoint(null);
  pages: Array<number>;
  agentIm: any;
  currentPage: number = 1;
  mode_montant: number;
  size: number = 20;
  title: string = "Statistique de remboursement par Agent"
  id_agent_actuel: any;
  constructor(public adminService: AdminService) {
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
  }
  ngOnInit() {
    this.agentIm = "";
    this.agent.infoEnregistrement.limite = this.size;
    this.agent.infoEnregistrement.pageActu = this.currentPage;

    let im_daf = 320744
    let im_li = "203 131 007 842"
    let im_chef = 322670
    if ( this.id_agent_actuel == im_chef || this.id_agent_actuel == im_daf || this.id_agent_actuel == im_li) {
      this.mode_montant = 1;
    } else {
      this.mode_montant = 11;
    }
    this.getListStatistiqueEnregistrerAgent();

  }

  getListStatistiqueEnregistrerAgent() {
    if (this.id_agent_actuel == this.agentIm ) {
      this.mode_montant = 1;
    }if(this.agentIm==""){
      this.mode_montant = 11;
    }

    if (this.agentIm.trim.length != 0 && (!this.agent.id) || this.agent.id == null) {
      this.agentIm = "";
      console.log("agent im " + this.agentIm);
    }
    this.adminService.getStatistiqueRemboursementParAgent(this.agent).subscribe(data => {
      this.agents = data;
      if (data && data.length != 0 && data[0].infoEnregistrement.totalPages) {
        this.pages = new Array(data[0].infoEnregistrement.totalPages);
        this.agent.infoEnregistrement.totalPages = data[0].infoEnregistrement.totalPages
      }
      else this.pages = new Array(0);
    }, err => {

    });



  }

  gotoPage(i: number) {
    if (i <= 0) return;
    if (i > this.pages.length) return;
    this.currentPage = i;
    this.agent.infoEnregistrement.pageActu = this.currentPage;
    //this.doSearch();
    this.getListStatistiqueEnregistrerAgent();

  }

  recupererInfoAgent() {
    // alert(this.agentIm);
    this.adminService.getConjoinsParIm(this.agentIm)
      .subscribe(data => {
        this.agent.agent_nom = data.agent_nom;
        this.agent.agent_prenom = data.agent_prenom;
        this.agent.id = data.id;
        //this.agent.agent_im=data.agent_im;


      }, err => {
        //console.log("taraiky");
        console.log(err);
      })
  }



  onKey(event: any) {
    console.log(event.target.value);
    let key2 = event.target.value;
    let count = event.target.value.length;
    console.log(count);
    this.agent = new Conjoint(null);
    this.currentPage = 1;

    this.agent.infoEnregistrement.limite = this.size;
    this.agent.infoEnregistrement.pageActu = this.currentPage;
    if (count >= 6) {
      console.log(event.target.value.length);
      //this.showDropDown=true;
      // this.statusLogged = '';
      this.recupererInfoAgent();

      //  console.log(data);
    }
  }

}
